function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { LANG } from '../utils/constant';
import { translate } from '../utils/helpers';
import CategoriesMenu from './CategoriesMenu';
import DelayMouseOver from '../utils/DelayMouseOver';
import MenuToggle from './MenuToggle';
import Search from './Search';
import FamiliesMenu from './FamiliesMenu';
import SectorsMenu from './SectorsMenu';
import MobileMenu from './MobileMenu';
import { Services } from '../utils/Services';
var menuStyle = {
  itemHeight: 30,
  paddingTop: 10,
  paddingBottom: 10
};

var MainMenu = /*#__PURE__*/function (_Component) {
  _inherits(MainMenu, _Component);

  var _super = _createSuper(MainMenu);

  function MainMenu(props) {
    var _this;

    _classCallCheck(this, MainMenu);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchCategories", function () {
      Services.fetchCategories().then(function (categories) {
        var minHeight = _this.state.minHeight;
        categories.forEach(function (category) {
          minHeight = category.sub_categories.length > minHeight ? category.sub_categories.length : minHeight;
          category.sub_categories.forEach(function (subCategory) {
            minHeight = subCategory.sub_sub_categories.length > minHeight ? subCategory.sub_sub_categories.length : minHeight;
          });
        });
        minHeight = minHeight * menuStyle.itemHeight + menuStyle.paddingTop + menuStyle.paddingBottom;

        _this.setState({
          categories: categories,
          minHeight: minHeight
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fetchSectors", function () {
      var _window$getSectors = window.getSectors,
          requestUrl = _window$getSectors.requestUrl,
          nonce = _window$getSectors.nonce;
      Services.fetchSectors(nonce, requestUrl).then(function (sectors) {
        return _this.setState({
          sectors: sectors
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fetchFamilies", function () {
      var _window$getFamilies = window.getFamilies,
          requestUrl = _window$getFamilies.requestUrl,
          nonce = _window$getFamilies.nonce;
      Services.fetchFamilies(nonce, requestUrl).then(function (families) {
        return _this.setState({
          families: families
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSearchIcon", function () {
      return document.querySelector('#main-menu').getAttribute('data-search-icon');
    });

    _defineProperty(_assertThisInitialized(_this), "getSearchIconReverse", function () {
      return document.querySelector('#main-menu').getAttribute('data-search-icon-reverse');
    });

    _defineProperty(_assertThisInitialized(_this), "setActiveMenu", function (activeMenu) {
      _this.setState({
        activeMenu: activeMenu
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeMenu", function () {
      return _this.setState({
        activeMenu: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMobileMenu", function () {
      _this.setState({
        mobileMenuOpen: !_this.state.mobileMenuOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getBackdropHeight", function () {
      return document.querySelector('body').offsetHeight - document.querySelector('.header').offsetHeight;
    });

    _defineProperty(_assertThisInitialized(_this), "getMenuHeight", function () {
      return _this.state.activeMenu == 'ino' ? {
        height: 'auto',
        minHeight: "".concat(_this.state.minHeight, "px")
      } : {
        height: "".concat(_this.state.minHeight, "px")
      };
    });

    _this.state = {
      activeMenu: null,
      categories: [],
      sectors: [],
      families: [],
      mobileMenuOpen: false,
      minHeight: 0
    };
    return _this;
  }

  _createClass(MainMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchCategories();
      this.fetchSectors();
      this.fetchFamilies();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.activeMenu === null && this.state.activeMenu !== null) {
        document.querySelector('html').classList.add('menu-open');
      }

      if (prevState.activeMenu !== null && this.state.activeMenu === null) {
        document.querySelector('html').classList.remove('menu-open');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          activeMenu = _this$state.activeMenu,
          categories = _this$state.categories,
          sectors = _this$state.sectors,
          families = _this$state.families,
          mobileMenuOpen = _this$state.mobileMenuOpen;
      return /*#__PURE__*/React.createElement("div", {
        className: "row d-flex menu-dropdown"
      }, /*#__PURE__*/React.createElement("div", {
        onClick: this.toggleMobileMenu,
        className: "products-search col-8 col-sm-6 col-md-6 d-md-flex d-lg-none"
      }, translate('PRODUCTS SEARCH', 'RECHERCHER'), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-down"
      })), categories.length && families.length ? /*#__PURE__*/React.createElement(MobileMenu, {
        closeMobileMenu: this.toggleMobileMenu,
        isOpen: mobileMenuOpen,
        categories: categories,
        sectors: sectors,
        families: families
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "col-7 col-md-6 col-lg-8 position-static d-none d-lg-block"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row "
      }, /*#__PURE__*/React.createElement(MenuToggle, {
        activeMenu: activeMenu,
        setActiveMenu: this.setActiveMenu,
        title: translate('Products', 'Produits')
      }), /*#__PURE__*/React.createElement(MenuToggle, {
        activeMenu: activeMenu,
        setActiveMenu: this.setActiveMenu,
        title: translate('ino lines', 'lignes ino')
      }), /*#__PURE__*/React.createElement(MenuToggle, {
        activeMenu: activeMenu,
        setActiveMenu: this.setActiveMenu,
        title: translate('Sectors', 'Secteurs')
      }), /*#__PURE__*/React.createElement("div", {
        className: "resources-menu main-box-hover",
        onMouseOver: function onMouseOver() {
          return _this2.setActiveMenu(null);
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: "/".concat(LANG, "/").concat(translate('resources-ino', 'ressources-ino'))
      }, /*#__PURE__*/React.createElement("span", null, translate('Resources', 'Ressources')))), /*#__PURE__*/React.createElement("div", {
        className: "sds-menu main-box-hover",
        onMouseOver: function onMouseOver() {
          return _this2.setActiveMenu(null);
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: "/".concat(LANG, "/shop/#/sds")
      }, /*#__PURE__*/React.createElement("span", null, translate('SDS', 'FDS')))), activeMenu !== null ? /*#__PURE__*/React.createElement("div", {
        className: "menu".concat(activeMenu === translate('sectors', 'secteurs') && sectors.length > 0 ? " market_container" : ""),
        style: this.getMenuHeight()
      }, activeMenu === translate('products', 'produits') && categories.length ? /*#__PURE__*/React.createElement(CategoriesMenu, {
        categories: categories,
        closeMenu: this.closeMenu
      }) : null, activeMenu === translate('ino lines', 'lignes ino') && families.length ? /*#__PURE__*/React.createElement(FamiliesMenu, {
        families: families,
        closeMenu: this.closeMenu
      }) : null, activeMenu === translate('sectors', 'secteurs') && sectors.length ? /*#__PURE__*/React.createElement(SectorsMenu, {
        sectors: sectors,
        closeMenu: this.closeMenu
      }) : null) : null, activeMenu !== null ? /*#__PURE__*/React.createElement(DelayMouseOver, {
        id: "header-dropdown-backdrop",
        onMouseOver: this.closeMenu
      }) : null, activeMenu !== null ? /*#__PURE__*/React.createElement(DelayMouseOver, {
        id: "dropdown-backdrop",
        style: {
          height: this.getBackdropHeight()
        },
        onMouseOver: this.closeMenu
      }) : null)), /*#__PURE__*/React.createElement(Search, {
        onMouseOver: function onMouseOver() {
          return _this2.setActiveMenu(null);
        },
        closeMenu: this.closeMenu,
        searchIcon: this.getSearchIcon(),
        searchIconReverse: this.getSearchIconReverse()
      }));
    }
  }]);

  return MainMenu;
}(Component);

export default MainMenu;